import { MinimalSymbol } from 'features/processFlowDiagrams/data/MinimalSymbols'
import CentrifugeDecanterScrewSolidShell from 'features/processFlowDiagrams/svg/centrifuges/centrifuge-decanter-screw-solid-shell.svg?react'
import CentrifugeHighSpeed from 'features/processFlowDiagrams/svg/centrifuges/centrifuge-high-speed.svg?react'
import CentrifugePerforatedShell from 'features/processFlowDiagrams/svg/centrifuges/centrifuge-perforated-shell.svg?react'
import CentrifugePusher from 'features/processFlowDiagrams/svg/centrifuges/centrifuge-pusher.svg?react'
import CentrifugeScrewPerforatedShell from 'features/processFlowDiagrams/svg/centrifuges/centrifuge-screw-perforated-shell.svg?react'
import CentrifugeSeparatorDisc from 'features/processFlowDiagrams/svg/centrifuges/centrifuge-separator-disc.svg?react'
import CentrifugeSkimmer from 'features/processFlowDiagrams/svg/centrifuges/centrifuge-skimmer.svg?react'
import CentrifugeSolidShell from 'features/processFlowDiagrams/svg/centrifuges/centrifuge-solid-shell.svg?react'
import React from 'react'

export const PID_CENTRIFUGES_SYMBOLS: MinimalSymbol[] = [
  {
    id: 'centrifuge-decanter-screw-solid-shell',
    name: 'Centrifuge, Decanter (Screw, Solid Shell)',
    category: 'centrifuges',
    svgContent: <CentrifugeDecanterScrewSolidShell />,
    viewBox: '0 0 110 100',
  },
  {
    id: 'centrifuge-high-speed',
    name: 'Centrifuge (High Speed)',
    category: 'centrifuges',
    svgContent: <CentrifugeHighSpeed />,
    viewBox: '0 0 100 110',
  },
  {
    id: 'centrifuge-perforated-shell',
    name: 'Centrifuge (Perforated Shell)',
    category: 'centrifuges',
    svgContent: <CentrifugePerforatedShell />,
    viewBox: '0 0 100 110',
  },
  {
    id: 'centrifuge-pusher',
    name: 'Centrifuge (Pusher)',
    category: 'centrifuges',
    svgContent: <CentrifugePusher />,
    viewBox: '0 0 110 100',
  },
  {
    id: 'centrifuge-screw-perforated-shell',
    name: 'Centrifuge (Screw, Perforated Shell)',
    category: 'centrifuges',
    svgContent: <CentrifugeScrewPerforatedShell />,
    viewBox: '0 0 110 100',
  },
  {
    id: 'centrifuge-separator-disc',
    name: 'Centrifuge (Separator Disc)',
    category: 'centrifuges',
    svgContent: <CentrifugeSeparatorDisc />,
    viewBox: '0 0 100 110',
  },
  {
    id: 'centrifuge-skimmer',
    name: 'Centrifuge (Skimmer)',
    category: 'centrifuges',
    svgContent: <CentrifugeSkimmer />,
    viewBox: '0 0 110 100',
  },
  {
    id: 'centrifuge-solid-shell',
    name: 'Centrifuge (Solid Shell)',
    category: 'centrifuges',
    svgContent: <CentrifugeSolidShell />,
    viewBox: '0 0 100 110',
  },
]
